import React from 'react';
import PropTypes from 'prop-types';

const FacetCharacterIndex = ({ characterIndex }) => {
  const alphabet = ['0-9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  return (
    <div className="facet-character-index">
      {alphabet.map((character, index) =>
        <a
          href={`#${character.toLowerCase()}`}
          key={`${characterIndex}-${character}`}
          className="facet-letter"
          style={{ zIndex: (index === 26) ? 3 : 1 }}
        >
          {character}
        </a>,
      )}
    </div>
  );
};

FacetCharacterIndex.propTypes = {
  characterIndex: PropTypes.arrayOf(PropTypes.string),
};

FacetCharacterIndex.defaultProps = {
  characterIndex: [],
};

export default FacetCharacterIndex;
